import Global from './actions/Global'
import Transactions from './actions/Transactions'
import Merchants from './actions/Merchants'

export default [
  Global,
  Transactions,
  Merchants,
]